import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AdsConfigService {
  isEnabled(): boolean {
    return !!(environment as any).ads_enable && !!this.getPublisherId();
  }

  getPublisherId(): string | undefined {
    return (environment as any).publisher_id;
  }

  getScriptUrl(): string {
    return `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${this.getPublisherId()}`;
  }
}
